/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
export const Colors = [
  '32c12c', '009888', '3e49bb', '092045', '000000',
  '87c735', '0fe1e1', '00a5f9', '469dbd', '272727',
  'fd51ff', 'ff9a00', 'd13c2b', '7c5547', '50342c',
  'ff97b2', 'ff5500', 'a82817', '4c2549', '9a999a'
];

export const UserColors = [
  '000000', '092045', '151515', '272727', '373737', '553827', '713624', '935934', 
  '00334c', '161c1b', '1d253b', '262e2d', '2b0f12', '37403f', '40474f', '492d32', 
  '4c2005', '4f2e65', '50342c', '5b5b63', '68786b', '696a6f', '7c5547', '0066cc',
  '006633', '9933cc', '993366', 'cc3300', '003366', '663399', '996633', '339966',
  '990000', '006699', '660033', '333399', '990033', '006600', '663300', '330066', 
  '336699', '993300', '003300', '330033', '003399', '996600', '660066', '336600',
  '660099', '990066', '006666'
];